function getExistingMachineNames(user) {
  return user.historicalMachine.map((machine) => machine.name);
}

function getExistingGrammarNames(user) {
  return user.historicalGrammar.map((machine) => machine.name);
}

function generateUniqueName(name, existingNames) {
  let newName = name;
  let counter = 1;

  while (existingNames.includes(newName)) {
    newName = `${name} (${counter})`;
    counter++;
  }

  return newName;
}

export { getExistingMachineNames, getExistingGrammarNames, generateUniqueName };
